import ApiService from "@/helpers/api.service.v6lite";

const API = new ApiService();


// Peddlr Lite (PEDDLR-7104) merchant store. All calls go to the /v6/lite gateway (peddlr_v6)
// via api.service.v6lite. This module is Lite-only and must not call Peddlr App (/subscriber/*) endpoints.

export const state = {
    businessDetails: {},
    subscriberList: [],
    subscriberPageInfo: {
        total: 0
    },
    reasonLogsList: [],
    reasonLogsPageInfo: {
        total: 0
    },
    businessQr: null,
    secQueHistory: [],
    // Peddlr Lite eload transaction drill-down (Digital Product > View)
    eloadTopupLogs: [],
    eloadTopupLogsPageInfo: {
        total: 0
    },
    eloadSellLogs: [],
    eloadSellLogsPageInfo: {
        total: 0
    }
}

export const mutations = {
    UPDATE_SUBSCRIBER_LIST(state, subscriber){
        let tempList = subscriber;

        state.subscriberList = tempList.map(data => {
            let accountType = data.kyc_acct_type
            switch (accountType) {
                case 'FullyVerified':
                    data.kyc_acct_type = "Fully Verified"
                    break;
                case 'FailedKYC':
                    data.kyc_acct_type = "Failed KYC"
                    break;
                case 'NoKYC':
                    data.kyc_acct_type = "Don't Have KYC"
                    break;
                default:
                    break;
            }

            let accountStatus = data.kyc_acct_status
            switch (accountStatus) {
                case 'PendingVerification':
                    data.kyc_acct_status = "Pending Verification"
                    break;
                case 'FailedVerification':
                    data.kyc_acct_status = "Failed Verification"
                    break;
                default:
                    break;
            }

            return data
        });
    },
    UPDATE_SUBSCRIBER_PAGE_INFO(state, total){
        state.subscriberPageInfo.total = total;
    },
    UPDATE_BUSINESS_INFO(state, info){
        state.businessDetails = info;
    },
    UPDATE_SEC_QUE_HISTORY(state, secQueHistory){
        state.secQueHistory = secQueHistory
    },
    UPDATE_REASON_LOGS(state, logs){
        state.reasonLogsList = logs;
    },
    UPDATE_REASON_LOGS_PAGE_INFO(state, total){
        state.reasonLogsPageInfo.total = total;
    },
    UPDATE_STORE_CATEGORY(state, info){
        const value = String(info || '').toLowerCase();
        state.businessDetails.storeCategory = value === 'sss' || value === 'sari sari store'
            ? 'Sari Sari Store'
            : 'Non Sari Sari Store';
    },
    UPDATE_BUSINESS_QR_INFO(state, base64img){
        state.businessQr = base64img;
    },
    SET_PROD_ERRORS(state, errors){
        state.errors = errors;
    },
    UPDATE_ELOAD_TOPUP_LOGS(state, list){
        state.eloadTopupLogs = list;
    },
    UPDATE_ELOAD_TOPUP_LOGS_PAGE_INFO(state, total){
        state.eloadTopupLogsPageInfo.total = total;
    },
    UPDATE_ELOAD_SELL_LOGS(state, list){
        state.eloadSellLogs = list;
    },
    UPDATE_ELOAD_SELL_LOGS_PAGE_INFO(state, total){
        state.eloadSellLogsPageInfo.total = total;
    },
}

export const actions = {
    getSubscriberListv2(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/list`, params)
            .then(({ data }) => {
                context.commit('UPDATE_SUBSCRIBER_LIST', data.message.rows);
                // Support both old format (rows2) and new format (pageInfo.total)
                const total = data.message.pageInfo
                    ? data.message.pageInfo.total
                    : (data.message.rows2 && data.message.rows2[0]
                        ? parseInt(data.message.rows2[0].total || 0)
                        : 0);
                context.commit('UPDATE_SUBSCRIBER_PAGE_INFO', total);
                resolve();
            })
            .catch(({ response }) => {
                console.log(response);
                reject();
            });
        });
    },
    getBusinessDetailsv2(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/merchant/info`, params)
            .then(({ data }) => {
                context.commit('UPDATE_BUSINESS_INFO', data.message[0]);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response?.data?.errors);
                reject();
            });
        });
    },
    fetchSecQueHistory(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/security-question-history`, params)
                .then(({ data }) => {
                    if (data.status === "ok") {
                        context.commit('UPDATE_SEC_QUE_HISTORY', data.message.row || []);
                        resolve(data)
                    } else {
                        context.commit('UPDATE_SEC_QUE_HISTORY', []);
                        reject(data.message)
                    }
                })
                .catch(({ response }) => {
                    console.log(response);
                    context.commit('UPDATE_SEC_QUE_HISTORY', []);
                    reject();
                });
          });
    },
    getKankolekMDR() {
        return new Promise((resolve, reject) => {
            API.get(`/merchant/kankolek-mdr-options`)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response?.data?.errors);
            });
        });
    },
    getKankolekMdrLogs(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/merchant/get-kankolek-mdr-logs`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response?.data?.errors);
            });
        });
    },
    getUserKankolekQR(context) {
        return new Promise((resolve, reject) => {
            API.post(`/merchant/get-kankolek-qr`, {
                "cognitoSub"        : context.state.businessDetails?.cogUserSub??null,
                "businessId"        : context.state.businessDetails?.businessId??null,
                "businessName"      : context.state.businessDetails?.businessName??null,
                "businessAddress"   : context.state.businessDetails?.businessAddress??null
            })
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    context.commit('UPDATE_BUSINESS_QR_INFO', data.message);
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response?.data?.errors);
            });
        });
    },
    updateMdrWhitelist(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/update-kankolek-mdr-settings`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response?.data?.errors);
                reject(response?.data?.errors);
            });
        });
    },
    updateWatchlistStatus(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/merchant/update-watchlist-status`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response?.data);
            });
        });
    },
    updateStoreCategory(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/merchant/update-store-category`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    context.commit('UPDATE_STORE_CATEGORY', params?.storeCategory);
                    resolve(data.message);
                }else{
                    reject(data.message);
                }
            })
            .catch(({ response }) => {
                reject(response?.data);
            });
        });
    },
    sendSecQue(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/send-security-question`, params)
                .then(({ data }) => {
                    if (data.status === "ok") {
                        resolve(data)
                    } else {
                        reject(data.message)
                    }
                })
                .catch(({ response }) => {
                    console.log(response)
                    reject();
                });
        });
    },
    // Peddlr Lite wallet freeze/enable (writes peddlr_v6 ref_user_wallet_status + txn_user_wallet_status_logs).
    updateUserWalletStatus(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/update-user-wallet-status`, params)
            .then(({ data }) => {
                if (data.status === "ok") {
                    resolve(data)
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response?.data?.errors);
                reject(response?.data?.errors);
            });
        });
    },
    // Current wallet freeze state per business, used to initialise the profileWallet toggles.
    getUserWalletsList(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/get-user-wallets-list`, params)
            .then(({ data }) => {
                if ((data?.status ?? "err") == "ok") {
                    resolve(data.message);
                } else {
                    reject(data.message);
                }
            })
            .catch(({ response }) => {
                reject(response?.data);
            });
        });
    },
    // Wallet freeze/enable reason log (paginated).
    getReasonLogsList(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/get-reason-logs`, params)
            .then(({ data }) => {
                if ((data?.status ?? "err") == "ok") {
                    context.commit('UPDATE_REASON_LOGS', data.message.rows);
                    context.commit('UPDATE_REASON_LOGS_PAGE_INFO', data.message.pageInfo.total);
                    resolve();
                } else {
                    context.commit('UPDATE_REASON_LOGS', []);
                    context.commit('UPDATE_REASON_LOGS_PAGE_INFO', 0);
                    reject(data.message);
                }
            })
            .catch(({ response }) => {
                context.commit('UPDATE_REASON_LOGS', []);
                context.commit('UPDATE_REASON_LOGS_PAGE_INFO', 0);
                reject(response?.data);
            });
        });
    },
    // Peddlr Lite eload transaction drill-down (Digital Product > View)
    getBusinessEloadTransaction(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/business-eload-transaction`, params)
                .then(({ data }) => {
                    if ((data?.status ?? "err") == "ok") {
                        resolve(data)
                    } else {
                        reject(data.message)
                    }
                })
                .catch(({ response }) => {
                    console.log(response)
                    reject();
                });
        });
    },
    getEloadTopupLogs(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/eload-topup-logs`, params)
                .then(({ data }) => {
                    context.commit('UPDATE_ELOAD_TOPUP_LOGS', data.message.rows);
                    context.commit('UPDATE_ELOAD_TOPUP_LOGS_PAGE_INFO', data.message.pageInfo.total);
                    resolve();
                })
                .catch(({ response }) => {
                    console.log(response)
                    context.commit('UPDATE_ELOAD_TOPUP_LOGS', []);
                    context.commit('UPDATE_ELOAD_TOPUP_LOGS_PAGE_INFO', 0);
                    reject();
                });
        });
    },
    getEloadSellLogs(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/merchant/eload-sell-logs`, params)
                .then(({ data }) => {
                    context.commit('UPDATE_ELOAD_SELL_LOGS', data.message.rows);
                    context.commit('UPDATE_ELOAD_SELL_LOGS_PAGE_INFO', data.message.pageInfo.total);
                    resolve();
                })
                .catch(({ response }) => {
                    console.log(response)
                    context.commit('UPDATE_ELOAD_SELL_LOGS', []);
                    context.commit('UPDATE_ELOAD_SELL_LOGS_PAGE_INFO', 0);
                    reject();
                });
        });
    },
}

export const getters = {

}
